import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import PatientRegistrationPage from './pages/PatientRegistrationPage';
import PatientSchedulePage from './pages/PatientSchedulePage';
import UpdateMeetingPage from './pages/UpdateMeetingPage';
import { PublicQuestionnaireWizardPage } from './pages/PublicQuestionnaireWizardPage';
import { QuestionnaireExitedPage } from './pages/QuestionnaireExitedPage';
import PatientLandingPage from './pages/PatientLandingPage';
import VideoLoading from './components/video/VideoLoading';

// Lazy: keeps the LiveKit client out of the bundle patients load for scheduling.
const VideoJoinPage = lazy(() => import('./pages/VideoJoinPage'));

// Patient-facing app: only public (no-auth) flows. Rendered on the patient
// domain (see config/appMode.ts). Reuses the exact same page components as the
// therapist app — no login, no AuthProvider/TenantProvider, no therapist routes.
function PatientApp() {
  return (
    <Routes>
      <Route path="/register/:clinicId" element={<PatientRegistrationPage />} />
      <Route path="/schedule/:patientUuid" element={<PatientSchedulePage />} />
      <Route path="/update-meeting/:uuid" element={<UpdateMeetingPage />} />
      <Route path="/join/:joinUuid" element={<Suspense fallback={<VideoLoading />}><VideoJoinPage /></Suspense>} />
      <Route path="/questionnaire/:token" element={<PublicQuestionnaireWizardPage />} />
      <Route path="/questionnaire/:tenantId/:questionnairePath" element={<PublicQuestionnaireWizardPage />} />
      <Route path="/questionnaire/exited" element={<QuestionnaireExitedPage />} />
      {/* Unknown/root URL → neutral landing, never the therapist login */}
      <Route path="*" element={<PatientLandingPage />} />
    </Routes>
  );
}

export default PatientApp;
